module.exports = __webpack_public_path__ + "media/images/application/image-shopping-5d7a5e7b2381b28ab9b1bb144bc48e89.svg";